"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BrigadeStore = void 0;

var _unistore = _interopRequireDefault(require("unistore"));

var _transformDataToProps = _interopRequireDefault(require("../EnhancedComponent/util/transformDataToProps"));

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var BrigadeStore =
/*#__PURE__*/
function () {
  function BrigadeStore(initialState, externalActions) {
    var _this = this;

    if (initialState === void 0) {
      initialState = {};
    }

    if (externalActions === void 0) {
      externalActions = {};
    }

    this.destroy = function () {
      _this.unwatch();

      _this.unsubscribe();
    };

    this.getExternalActions = function () {
      return _this.externalActions;
    };

    this.getState = function () {
      return _this.__store.getState();
    };

    this.setState = function (newState) {
      return _this.__store.setState(newState);
    };

    this.action = function (action) {
      return _this.__store.action(action);
    };

    this.subscribe = function (callback) {
      return _this.__store.subscribe(callback);
    };

    this.unsubscribe = function (listener) {
      return _this.__store.unsubscribe(listener);
    };

    // Secret store within the store
    this.__store = (0, _unistore.default)((0, _transformDataToProps.default)(initialState));
    this.initialState = initialState;
    this.externalActions = externalActions;
    this.models = (0, _utils.getModelsFromProps)(initialState);
    this.collections = (0, _utils.getCollectionsFromProps)(initialState);
    this.watch();
  }

  var _proto = BrigadeStore.prototype;

  _proto.updatePropsFromBackboneChange = function updatePropsFromBackboneChange(nextInstance) {
    var _this$__store$setStat;

    // Collection vs. Model check. If nextInstance is a model from a collection,
    // we want a reference to the collection.
    var backboneInstance = nextInstance.collection ? nextInstance.collection : nextInstance;
    var key = backboneInstance[_utils.BRIGADE_MODEL_KEY];
    if (!key) return;
    var props = backboneInstance.toJSON();

    this.__store.setState((_this$__store$setStat = {}, _this$__store$setStat[key] = props, _this$__store$setStat));
  };

  _proto.unwatch = function unwatch() {
    var _this2 = this;

    this.collections.forEach(function (collection) {
      collection.off(_utils.COLLECTION_EVENTS, _this2.updatePropsFromBackboneChange, _this2);
    });
    this.models.forEach(function (model) {
      model.off(_utils.MODEL_EVENTS, _this2.updatePropsFromBackboneChange, _this2);
    });
  };

  _proto.watch = function watch() {
    var _this3 = this;

    this.collections.forEach(function (collection) {
      collection.on(_utils.COLLECTION_EVENTS, _this3.updatePropsFromBackboneChange, _this3);
    });
    this.models.forEach(function (model) {
      model.on(_utils.MODEL_EVENTS, _this3.updatePropsFromBackboneChange, _this3);
    });
  }
  /**
   * The first argument of an action is `state`. This method returns the
   * externalActions re-mapped such that the first argument is dropped.
   * This is useful if the code you are connecting via externalActions has no
   * concept of state or the store.
   * @return Object
   */
  ;

  _proto.getStatelessExternalActions = function getStatelessExternalActions() {
    var actions = this.getExternalActions();
    return Object.keys(actions).reduce(function (accumulator, key) {
      var _extends2;

      return _extends({}, accumulator, (_extends2 = {}, _extends2[key] = function () {
        for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          rest[_key - 1] = arguments[_key];
        }

        return actions[key].apply(actions, rest);
      }, _extends2));
    }, {});
  };

  return BrigadeStore;
}();

exports.BrigadeStore = BrigadeStore;

var createStore = function (initialState, externalActions) {
  return new BrigadeStore(initialState, externalActions);
};

var _default = createStore;
exports.default = _default;